import { Project } from "~/gql/types";
import moment from "moment";
import type { Moment } from "moment";

export const validateProjectDate = (
  project: Project,
  selectedDate: Moment
): string | undefined => {
  const momentDate = (date: string): Moment => moment(date, "YYYY-MM-DD");

  if (project && selectedDate) {
    const { actualStartDate, actualEndDate } = project;
    const formattedDate = selectedDate.format("YYYY-MM-DD");

    if (actualStartDate && momentDate(actualStartDate).isAfter(selectedDate)) {
      return `Project ${project.name} (${project.number}) has a start date which is after ${formattedDate}`;
    }

    if (actualEndDate && momentDate(actualEndDate).isBefore(selectedDate)) {
      return `Project ${project.name} (${project.number}) has an end date which is before ${formattedDate}`;
    }
  }
};
